import delegationAssembler from './vacationDelegation.assemblers';
import { MODULE_ID } from 'vacations-absences.module/common/domain/constants';
import moment from 'moment';
import 'twix';

class vacationDelegationService {
  constructor($http, DelegationService) {
    'ngInject';
    this.http = $http;
    this.delegationService = DelegationService;
  }

  getDelegations(employeeId) {
    return this.delegationService.getDelegations(employeeId, MODULE_ID).then((response) => {
      return delegationAssembler.assemble(response.data);
    });
  }

  deleteDelegation(employeeId, delegationToDelete) {
    return this.delegationService.cancelDelegation(employeeId, delegationToDelete);
  }

  updateDelegation(employeeId, delegationToUpdate) {
    return this.delegationService.updateDelegations(employeeId, delegationToUpdate);
  }

  createDelegation(employeeId, delegationToCreate) {
    return this.delegationService.createDelegations(employeeId, delegationToCreate);
  }

  hasDelegated(employeeId) {
    return this.delegationService.getDelegations(employeeId, MODULE_ID).then((response) => {
      let delegations = response.data.delegations;
      let isDelegationActive = this._isDelegationActiveToday(delegations);
      let resultDelegation = {
        hasDelegated: !!delegations.length && isDelegationActive,
        delegations: delegations,
      };
      return resultDelegation;
    });
  }

  _isDelegationActiveToday(delegations) {
    return delegations.some((delegation) => {
      const todayFormatted=moment().format('YYYY-MM-DD');
      const delegationStartDate=delegation.startDate;
      let delegationEndDate=delegation.endDate;

      if (todayFormatted===delegationEndDate) { // When the delegation end date is today, overlaps returns false
        delegationEndDate=moment(delegationEndDate).add('days', 1).format('YYYY-MM-DD');
      }

      const delegationDateRange = moment(delegationStartDate).twix(delegationEndDate);
      const today = new Date();
      const todayRange = new moment(today).twix(today);
      return todayRange.overlaps(delegationDateRange);
    });
  }

  findDelegationActive(today, delegations) {
    let delegationToReturn = delegations.find(delegation => {
      return this._checkDataDelegation(delegation, today);
    });

    return (delegationToReturn !== undefined) ? delegationToReturn : {};
  }

  _checkDataDelegation(delegation, today) {
    let endDateSmaller = today <= delegation.endDate;
    let startDateGreater = today >= delegation.startDate;
    return endDateSmaller && startDateGreater;
  }

}

export default vacationDelegationService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/delegationRepository/vacationDelegationRepository.service.js